export default (intAmount: number) => new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',

  // These options are needed to round to whole numbers if that's what you want.
  // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  // minimumFractionDigits: 0,
  // maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
}).format(intAmount);
